import { positionRight } from '@reach/popover';
import React from 'react';
import styled from 'styled-components';
import { MenuButton, tokens, MenuItem, Menu, Columns, Column, Stack, Text, Inline, Box, Icon } from '@happy-design/react';
import { useTranslate } from '../../lib/translate.js';
import { useNavContext } from '../nav/Nav.js';
import { useExperienceSwitcher } from './ExperienceSwitcherContext.js';
import { ExpandAllSVG } from './Graphics.js';

const CustomerSwitcherMenuButton = styled(MenuButton)`
  && {
    color: ${tokens.color.text.default};
    background: ${tokens.color.palette.gray[5]};
    border-radius: 0 0 ${tokens.size["border-radius"].xl} 0;

    text-align: left;
    padding: 1rem 1.5rem 1.5rem 1.25rem;
    height: 5rem;
    border-top: 1px solid ${tokens.color.palette.gray[10]};
  }
  &:hover {
    background: ${tokens.color.palette.gray[5]};
  }
`;
const CustomerSwitcherMenuItem = styled(MenuItem)`
  && {
    padding-right: 2.5rem;
    height: 2rem;
  }
  .customer-active svg {
    margin-top: -2px;
    stroke: currentColor;
    stroke-width: 0.5;
  }
`;
const Divider = styled.div`
  border-top: solid 1px ${tokens.color.palette.gray[10]};
`;
const positionOffset = (targetRect, popoverRect)=>{
    const position = positionRight(targetRect, popoverRect);
    const left = parseInt(position.left.toString());
    const top = parseInt(position.top.toString());
    if (!isNaN(left) && !isNaN(top)) {
        return {
            top: `${top + 24}px`,
            left: `${left - 24}px`
        };
    }
    return position;
};
const Customer = (props)=>{
    const nav = useNavContext();
    const uxs = useExperienceSwitcher();
    const t = useTranslate();
    return React.createElement(Menu, {
        testId: "ExperienceSwitcher-BusinessSwitcher",
        position: positionOffset
    }, React.createElement(CustomerSwitcherMenuButton, {
        testId: "ExperienceSwitcher-BusinessSwitcher"
    }, React.createElement(Columns, {
        gap: 1
    }, React.createElement(Column, {
        span: 1
    }, React.createElement(Stack, {
        gap: 0.33
    }, React.createElement(Text, {
        size: "medium",
        weight: "bold",
        truncate: true
    }, uxs.activeCustomer?.name ?? ""), React.createElement(Text, {
        size: "medium",
        weight: "regular"
    }, nav.currentUser.email))), React.createElement(Column, {
        span: "content"
    }, React.createElement(Inline, {
        alignY: "bottom"
    }, React.createElement(ExpandAllSVG, null))))), uxs.customers.length > 1 && React.createElement(React.Fragment, null, uxs.customers.map((customer)=>React.createElement(CustomerSwitcherMenuItem, {
            key: customer.id,
            testId: "Customer-" + customer.id,
            isSelected: uxs.activeCustomer?.id === customer.id,
            onSelect: ()=>{
                uxs.setActiveCustomerId(customer.id);
            }
        }, React.createElement(Box, {
            minWidth: 14
        }, React.createElement(Text, {
            size: "medium",
            truncate: true,
            color: uxs.activeCustomer?.id === customer.id ? "blurple100" : "slateGrey100"
        }, customer.name), uxs.activeCustomer?.id === customer.id && React.createElement(Icon, {
            className: "customer-active",
            icon: "check",
            size: 0.75
        })))), React.createElement(Box, {
        minHeight: 0.5
    }), React.createElement(Divider, {
        key: "divider"
    })), React.createElement(MenuItem, {
        variant: "danger-inverse",
        testId: "SignOut",
        onSelect: props.onSignOut
    }, React.createElement(Text, {
        color: "red100",
        size: "medium"
    }, t("nav:ExperienceSwitcher.sign_out"))));
};

export { Customer };
